import { useRef, useState } from "react";
import { motion } from "framer-motion";

export const TiltCard = ({ children, className = "", ...props }) => {
  const ref = useRef(null);
  const [style, setStyle] = useState({});

  const onMove = (e) => {
    const rect = ref.current.getBoundingClientRect();
    const x = (e.clientX - rect.left) / rect.width;
    const y = (e.clientY - rect.top) / rect.height;
    const rx = (0.5 - y) * 10;
    const ry = (x - 0.5) * 10;
    setStyle({ transform: `perspective(1000px) rotateX(${rx}deg) rotateY(${ry}deg) scale(1.02)` });
  };
  const onLeave = () => setStyle({ transform: "perspective(1000px) rotateX(0deg) rotateY(0deg) scale(1)" });

  return (
    <div ref={ref} className={`tilt-wrap ${className}`} onMouseMove={onMove} onMouseLeave={onLeave} {...props}>
      <div className="tilt-card" style={style}>{children}</div>
    </div>
  );
};

export const Particles = ({ count = 35 }) => {
  const items = Array.from({ length: count }, (_, i) => ({
    id: i,
    left: `${(i * 37) % 100}%`,
    top: `${(i * 53) % 100}%`,
    delay: `${(i % 5) * 0.8}s`,
    size: 2 + (i % 3),
  }));
  return (
    <div className="particles" aria-hidden="true">
      {items.map((p) => (
        <span key={p.id} className="particle" style={{ left: p.left, top: p.top, animationDelay: p.delay, width: p.size, height: p.size }} />
      ))}
    </div>
  );
};

export const HoloNotify = ({ icon: Icon, title, body, onClose }) => (
  <motion.div
    className="holo-notify"
    initial={{ opacity: 0, x: 50, scale: 0.9 }}
    animate={{ opacity: 1, x: 0, scale: 1 }}
    exit={{ opacity: 0, x: 50, scale: 0.9 }}
  >
    {Icon && <Icon className="h-5 w-5 text-[#00D4FF]" />}
    <div>
      <p className="text-sm font-bold text-white">{title}</p>
      <p className="text-xs text-slate-400">{body}</p>
    </div>
    {onClose && <button onClick={onClose} className="ml-2 text-slate-500 hover:text-white">✕</button>}
  </motion.div>
);
